import type { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export function getPersonalizedInsertRouteChildren(): PermissionedRouteObject[] {
  return [
    {
      index: true,
      async lazy() {
        const { PersonalizedSlipsPage } =
          // redont-allow-dynamic-import: route-level code splitting
          await import("@redotech/redo-merchant-fulfillment-app/personalized-slips/personalized-slips-page");
        return { Component: PersonalizedSlipsPage };
      },
    },
    {
      path: ":personalizedSlipId",
      handle: { breadcrumb: "Personalized insert builder" },
      async lazy() {
        const { PersonalizedSlipsBuilderPage } =
          // redont-allow-dynamic-import: route-level code splitting
          await import("@redotech/redo-merchant-fulfillment-app/personalized-slips/personalized-slip-builder");
        return { Component: PersonalizedSlipsBuilderPage };
      },
    },
  ];
}
